import React, { useEffect, useState } from "react"
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  NavItem,
  NavLink,
  Form,
  Input,
  InputGroup,
  TabContent,
  TabPane,
  CardHeader,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from "axios"

import toastr from "toastr"
import "toastr/build/toastr.min.css"

import { add } from "lodash"
import { series } from "common/data/projects"
import { connect } from "formik"
import Select from "react-select"
import { use } from "i18next"
import { check } from "prettier"
import apiURl from "url"
const CourierInfo = props => {
  //meta title
  document.title = "Courier Info"
  const navigate = useNavigate()

  const [isChecked, setIsChecked] = useState(false)
  const [MainService, setMainService] = useState("")

  const [DocSubService, setDocSubService] = useState([])
  const [DocSubServiceData, setDocSubServiceData] = useState([])

  const [DepTypeCharges, setDepTypeCharges] = useState("")


  const [DocSSOption, setDocSSOption] = useState("")
  const [DepTypeChargesOption, setDepTypeChargesOption] = useState([])
  const [SubService, setSubService] = useState("")
  const [Sector, setSector] = useState("")
  const [MSoption, setMSoption] = useState([])
  const [Rname, setRname] = useState("")
  const [RiderOption, setRideroption] = useState([])
  const [TotalDepChargesAmount, setTotalDepChargesAmount] = useState('0')
  const [apiLoaded, setApiLoaded] = useState(false)

  const [oto, setOto] = useState(false)
  const [otd, setOtd] = useState(false)
  const [wc, setWc] = useState(false)
  const [ctc, setCtc] = useState(false)

  const login_user_id = localStorage.getItem("login_user_id")
  const role = localStorage.getItem("role")

  const [parcelWeight, setParcelWeight] = useState({
    label: "0.5",
    value: "0.5",
  })

  const [paymentM, setpaymentm] = useState(null)
  //Parcel Info
  const [FormData, setFormData] = useState({
    s_fullName: "",
    s_cnic: "",
    s_phone: "",
    s_address: "",

    r_fullName: "",
    r_phone: "",
    r_cnic: "",
    r_address: "",

    service_name: "",
    doc_sub_service: "",
    sub_service_name: "",
    sector_: "",

    content_no: "1",
    content_weight: "0",
    contents_value: "0",
    content_info: "",

    assign_to: "",

    receive_location: "",
    send_location: "",

    employee_name: "",
    employee_id: "",
    employee_city: "",

    subtotal_: "0.00",
    original_subtotal: "0",

    //Documents Data
    office_door_option: "",
    city_options: "",
    no_of_docs: "1",
    Docs_subtotal_: "0",
    cvi_percent: false,
    document_detail: "",
    doc_cvi_amount: "0",

    //Payment Method
    payment_method: "",
  })

  useEffect(() => {
    // Update content_weight based on sub_service_name
    if (FormData.sub_service_name === "box") {
      setFormData(prevState => ({
        ...prevState,
        content_weight: "1",
      }))
    } else {
      setFormData(prevState => ({
        ...prevState,
        content_weight: "0.5",
      }))
    }
  }, [FormData.sub_service_name])

  const handleParcel = e => {
    const { name, value } = e.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }))
  }

  //Service option
  const [serviceOption, setServiceOption] = useState({
    oto_wc_3docs: "",
    oto_wc_addocs: "",
    oto_ctc_3docs: "",
    oto_ctc_adddoc: "",

    otd_wc_3docs: "",
    otd_wc_addocs: "",
    otd_ctc_3docs: "",
    otd_ctc_adddoc: "",
  })
  const fetchDocumentData = async subService => {
    const URL = `${apiURl}/fetchDocumentService?sub_service=${subService}`
    try {
      const response = await axios.get(URL)
      if (response.data.status === "success") {
        const documentData = response.data.documentData[0]
        setServiceOption(prev => ({
          oto_wc_3docs: +prev.oto_wc_3docs + +(documentData?.oto_wc_3docs || 0),
          oto_wc_addocs: +prev.oto_wc_addocs + +(documentData?.oto_wc_Addocs || 0),
          oto_ctc_3docs: +prev.oto_ctc_3docs + +(documentData?.oto_ctc_3docs || 0),
          oto_ctc_adddoc: +prev.oto_ctc_adddoc + +(documentData?.oto_ctc_Addocs || 0),
          otd_wc_3docs: +prev.otd_wc_3docs + +(documentData?.otd_wc_3docs || 0),
          otd_wc_addocs: +prev.otd_wc_addocs + +(documentData?.otd_wc_Addocs || 0),
          otd_ctc_3docs: +prev.otd_ctc_3docs + +(documentData?.otd_ctc_3docs || 0),
          otd_ctc_adddoc: +prev.otd_ctc_adddoc + +(documentData?.otd_ctc_Addocs || 0),
        }))
      } else {
        console.error("Failed to fetch document service data")
      }
    } catch (err) {
      console.error("Error:", err)
    }
  }
  
  const [DelOpt1, setDelOpt1] = useState(false)
  const handleOfficDoorService = event => {
    const selectedValue = event.target.value
    setFormData(prevData => ({
      ...prevData,
      office_door_option: selectedValue,
    }))
    if (selectedValue === "oto_") {
      setOto(true)
      setOtd(false)
    } else if (selectedValue === "otd_") {
      setOtd(true)
      setOto(false)
    }
  if (selectedValue && selectedValue !== "null") {
    setDelOpt1(true)
  } else {
    setDelOpt1(false)
  }
  }

  const [DelOpt2, setDelOpt2] = useState(false)
  const handlecityoptions = event => {
    const selectedValue = event.target.value
    setFormData(prvdata => ({
      ...prvdata,
      city_options: selectedValue,
    }))

    if (selectedValue === "wc_") {
      setWc(true)
      setCtc(false)
    } else if (selectedValue === "ctc_") {
      setCtc(true)
      setWc(false)
    } else {
      setCtc(false)
      setWc(false)
    }

    if (selectedValue && selectedValue !== "null") {
      setDelOpt2(true)
    } else {
      setDelOpt2(false)
    }
  }

  const handledocsNo = event => {
    const { name, value } = event.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }))
  }

  //Fetch Doc Sub Service Data
  //Fetch Document DAta
  const fetchServiceDocumentData = () => {
    const URL = `${apiURl}/fetchServiceDocumentData`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const DocSubSoption = response.data.DocserviceData.map(row => ({
            label: row.doc_sub_service,
            value: row.doc_sub_service,
          }))
          setDocSSOption(DocSubSoption)
        } else {
          console.error("Failed to fetch sub service :", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching service data:", error)
      })
  }

  //Fetch Department Type Sub Cherges
  const fetchDepTypeChargesData = () => {
    const URL = `${apiURl}/Get_Dep_Charges_Type`;
  
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success" && Array.isArray(response.data.data)) {
          const DepCharges = [
            { label: "None", value: null }, // Default option
            ...response.data.data.map(row => ({
              label: row.name_,  // Display name in dropdown
              value: row.id,  // Store ID for selection
              amount: row.amount_, // Additional info if needed
            })),
          ];
          setDepTypeChargesOption(DepCharges);
        } else {
          console.error("Failed to fetch charges:", response.data.message);
        }
      })
      .catch(error => {
        console.error("Error fetching service data:", error);
      });
  };
  
  useEffect(() => {
    fetchServiceDocumentData()
    fetchDepTypeChargesData()
  }, [])

  // Fetch Documents Service
  const handleDocCheckbox = () => {
    if (DocumentMode) {
      if (FormData.doc_cvi_amount === "" || FormData.doc_cvi_amount === "0") {
        toastr.error("Set CVI Amount")
      } else {
        setIsChecked(prevState => !prevState)
        setFormData(prevData => ({
          ...prevData,
          cvi_percent: !isChecked,
        }))
      }
    } else {
      if (FormData.contents_value === "" || FormData.contents_value === "0") {
        toastr.error("Set Content Value")
      } else {
        setIsChecked(prevState => !prevState)
        setFormData(prevData => ({
          ...prevData,
          cvi_percent: !isChecked,
        }))
      }
    }
  }

  useEffect(() => {
    // Calculate 2.5% of contents_value
    const cviAmount = parseFloat(FormData.contents_value) * 0.025
    const subtotal = parseFloat(FormData.subtotal_)
    const original_subtotal = parseFloat(FormData.original_subtotal)
    const total = subtotal + cviAmount
    // Check if the checkbox is checked and cviAmount hasn't been added yet
    if (FormData.cvi_percent === true) {
      // Add cviAmount to subtotal_
      setFormData(prevData => ({
        ...prevData,
        subtotal_: parseFloat(total).toFixed(2),
      }))
    } else {
      // Subtract cviAmount from subtotal_ if checkbox is unchecked and cviAmount has been added
      setFormData(prevData => ({
        ...prevData,
        subtotal_: parseFloat(original_subtotal).toFixed(2),
      }))
      // Set cviAdded to false to indicate that cviAmount has been subtracted
    }
  }, [
    FormData.contents_value,
    FormData.cvi_percent,
    FormData.original_subtotal,
  ])

  //const DocumentMode
  const [DocumentMode, setDocumentMode] = useState(false)
  const [DepchargesMode, setDepchargesMode] = useState(false)
  //Department Charges Handle 
  const initialvalue = [{
    id:1,
    dep_charges_name: null,
    dep_charges_amount: null,
    dep_charges_selected_no:'0',
    dep_charges_selected_doc_amount:'0',
  }]
  const [DepChargesData, setDepChargesData] = useState(initialvalue)

  //set Doc Main Service
  const handleMainService = selectedOption => {
    setFormData(prevData => ({
      ...prevData,
      service_name: selectedOption.value,
    }))
    setDocSubService([])
    setDepChargesData(initialvalue)
    setDocumentMode(false)
    setDepchargesMode(false)
    if (selectedOption.value === "Docs. Attestation") {
      setDocumentMode(true)
      setFormData(prevData => ({
        ...prevData,
        r_fullName: "ECS",
        r_address: "Office # 1-LG F&F Mall G-6 Islamabad",
      }))
    } else {
      setDocumentMode(false)
      setFormData(prevData => ({
        ...prevData,
        r_fullName: "",
        r_address: "",
        Docs_subtotal_: "0",
        office_door_option: "",
        city_options: "",
        no_of_docs: "1",
      }))
      setDelOpt1(false)
      setDelOpt2(false)
    }
    setMainService(selectedOption)
  }

  //Set Doc Sub Service
  const [subS, setsubS] = useState(false)
  const handleDocSubService = async selectedOptions => {

    setDepchargesMode(false)
    setDepChargesData(initialvalue)
  
    const selectedValues = selectedOptions.map(opt => opt.value)
    const apostilleSelected = selectedValues.includes("Apostille")
  
    if (apostilleSelected) setDepchargesMode(true)
  
    setDocSubService(selectedOptions)
    setFormData(prev => ({
      ...prev,
      doc_sub_service: selectedValues.join(", ")
    }))

    if(selectedOptions.length !== 0 && selectedOptions !== 'null'){
      setsubS(true)
    }else{
      setsubS(false)
    }
  
    const delivery = FormData.office_door_option
    const city = FormData.city_options
  
    const newRows = []
  
    for (let option of selectedOptions) {
      const alreadyExists = DocSubServiceData.find(row => row.id === option.value)
      if (alreadyExists) {
        newRows.push(alreadyExists) // ✅ keep the current row
        continue
      }
  
      const res = await axios.get(`${apiURl}/fetchDocumentService?sub_service=${option.value}`)
      const docData = res.data.documentData?.[0] || {}
  
      let base = 0
      let extra = 0
      if (delivery === "oto_" && city === "wc_") {
        base = parseFloat(docData.oto_wc_3docs || 0)
        extra = parseFloat(docData.oto_wc_Addocs || 0)
      } else if (delivery === "oto_" && city === "ctc_") {
        base = parseFloat(docData.oto_ctc_3docs || 0)
        extra = parseFloat(docData.oto_ctc_Addocs || 0)
      } else if (delivery === "otd_" && city === "wc_") {
        base = parseFloat(docData.otd_wc_3docs || 0)
        extra = parseFloat(docData.otd_wc_Addocs || 0)
      } else if (delivery === "otd_" && city === "ctc_") {
        base = parseFloat(docData.otd_ctc_3docs || 0)
        extra = parseFloat(docData.otd_ctc_Addocs || 0)
      }
  
      const docCount = 1
      const total = base

      newRows.push({
        id: option.value,
        name: option.value,
        doc_count: docCount,
        rate: base,
        docData: docData,
        total: total
      })
    }
  
    setDocSubServiceData(newRows)
  }
  
  

 const handleDocRowChange = (index, doc_count) => {
    setDocSubServiceData(prev => {
      const updated = [...prev]
      updated[index].doc_count = doc_count
  
      const delivery = FormData.office_door_option
      const city = FormData.city_options
      const docData = updated[index].docData || {}
  
      let base = 0
      let extra = 0
  
      if (delivery === "oto_" && city === "wc_") {
        base = parseFloat(docData.oto_wc_3docs || 0)
        extra = parseFloat(docData.oto_wc_Addocs || 0)
      } else if (delivery === "oto_" && city === "ctc_") {
        base = parseFloat(docData.oto_ctc_3docs || 0)
        extra = parseFloat(docData.oto_ctc_Addocs || 0)
      } else if (delivery === "otd_" && city === "wc_") {
        base = parseFloat(docData.otd_wc_3docs || 0)
        extra = parseFloat(docData.otd_wc_Addocs || 0)
      } else if (delivery === "otd_" && city === "ctc_") {
        base = parseFloat(docData.otd_ctc_3docs || 0)
        extra = parseFloat(docData.otd_ctc_Addocs || 0)
      }
  
      if (doc_count <= 3) {
        updated[index].total = base
      } else {
        updated[index].total = base + (doc_count - 3) * extra
      }
      return updated
    })
  }
  

  useEffect(() => {
    const total = DocSubServiceData.reduce((acc, row) => acc + Number(row.total), 0)
    const docCount = DocSubServiceData.reduce((acc, row) => acc + Number(row.doc_count), 0)
    // const depCount = DepChargesData.reduce((acc, row) => acc + Number(row.dep_charges_selected_no || 0), 0)
  
    let finalTotal = total
  
    if (isChecked) {
      const CviAmount = parseFloat(FormData.doc_cvi_amount) || 0
      finalTotal += (2.5 / 100) * CviAmount
    }
  
    setFormData(prev => ({
      ...prev,
      Docs_subtotal_: finalTotal.toFixed(2),
      no_of_docs: docCount,
    }))
  }, [DocSubServiceData, DepChargesData, isChecked, FormData.doc_cvi_amount])
  
  
  
  //Department Charges
  //select Type
  const handleDeptypeCharges = (index, selectedOption) => {
    
    setDepChargesData(prevData => {
      const updatedData = [...prevData];
      const selectedAmount = selectedOption.amount || 0; // Ensure a default value if amount is undefined
      const selectedNo = updatedData[index].dep_charges_selected_no || 1; // Default to 1 if no value set
  
      updatedData[index] = {
        ...updatedData[index],
        dep_charges_name: selectedOption.label === 'None' ? null : selectedOption.label,
        dep_charges_amount: selectedAmount,
        dep_charges_selected_no: '1',
        dep_charges_selected_doc_amount: selectedAmount * '1', // Multiply amount and number
      };
      return updatedData;
    });
  };
  
  //select num
  const handleDeptypeChargesDocNum = (index, e) => {
    const { name, value } = e.target
  
    setDepChargesData(prevData => {
      const updatedData = [...prevData]
      const selectedNo = value ? parseInt(value) : 1
      const selectedAmount = updatedData[index].dep_charges_amount || 0
  
      updatedData[index] = {
        ...updatedData[index],
        [name]: value,
        dep_charges_selected_doc_amount: selectedAmount * selectedNo,
      }
  
      return updatedData
    })
  }
  
  const handleAddRow = () => {
   const NewRowId = DepChargesData.length + 1;
   const newRow = {
    id:NewRowId,
    dep_charges_name: null,
    dep_charges_amount: null,
    dep_charges_selected_no:'0',
    dep_charges_selected_doc_amount:'0',
   }
   setDepChargesData(prev => [...prev, newRow])
  }
  const handleDelRow =(id) => {
    const updateData = DepChargesData.filter(item => item.id !== id)
    setDepChargesData(updateData)
  }

  useEffect(() => {
    setDocSubServiceData(prev => {
      const updated = [...prev]
      const apostilleIndex = updated.findIndex(row => row.name === "Apostille")
  
      if (apostilleIndex !== -1) {
        const totalDocs = DepChargesData.reduce((sum, row) => {
          return row.dep_charges_name && row.dep_charges_name !== "None"
            ? sum + parseInt(row.dep_charges_selected_no || 0)
            : sum
        }, 0)
  
        updated[apostilleIndex].doc_count = totalDocs
  
        const delivery = FormData.office_door_option
        const city = FormData.city_options
        const docData = updated[apostilleIndex].docData || {}
  
        let base = 0
        let extra = 0
  
        if (delivery === "oto_" && city === "wc_") {
          base = parseFloat(docData.oto_wc_3docs || 0)
          extra = parseFloat(docData.oto_wc_Addocs || 0)
        } else if (delivery === "oto_" && city === "ctc_") {
          base = parseFloat(docData.oto_ctc_3docs || 0)
          extra = parseFloat(docData.oto_ctc_Addocs || 0)
        } else if (delivery === "otd_" && city === "wc_") {
          base = parseFloat(docData.otd_wc_3docs || 0)
          extra = parseFloat(docData.otd_wc_Addocs || 0)
        } else if (delivery === "otd_" && city === "ctc_") {
          base = parseFloat(docData.otd_ctc_3docs || 0)
          extra = parseFloat(docData.otd_ctc_Addocs || 0)
        }
  
        updated[apostilleIndex].total =
        totalDocs === 0 ? 0 : totalDocs <= 3 ? base : base + (totalDocs - 3) * extra

      }
  
      return updated
    })
  }, [DepChargesData, FormData.office_door_option, FormData.city_options])
  

  useEffect(() => {
    const sum = DepChargesData.reduce(
      (acc, row) => acc + Number(row.dep_charges_selected_doc_amount || 0),
      0
    )
  
    setTotalDepChargesAmount(sum)
  }, [DepChargesData])
  

  //Fetch Only Service
  const fetchServiceName = () => {
    const URL = `${apiURl}/fetchServiceData`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const options = response.data.serviceData.map(row => ({
            label: row.service_name,
            value: row.service_name,
          }))
          setMSoption(options)
        } else {
          console.error("Failed to fetch service data:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching service data:", error)
      })
  }

  //Fetch Services Detial
  const fetchSubServiceChargesData = (MS, SS, SC, PW) => {
    const URL = `${apiURl}/fetchServiceChargesData`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const serviceChargesData = response.data.serviceChargesData
          if (serviceChargesData.length > 0) {
            // Find the selected service object for the provided weight
            let selectedServiceCharges = serviceChargesData.find(service => {
              return (
                service.sub_service === SS &&
                service.service_sector === SC &&
                service.parcel_weight === PW
              )
            })

            // If service charges for the provided weight are not found, fall back to default weight (1 kg)

            if (!selectedServiceCharges && PW !== "1") {
              selectedServiceCharges = serviceChargesData.find(service => {
                return (
                  service.sub_service === SS &&
                  service.service_sector === SC &&
                  service.parcel_weight === "1" // Fall back to default weight (1 kg)
                )
              })
            }

            // For Box
            let totalServiceCharges = 0
            if (selectedServiceCharges) {
              totalServiceCharges = parseFloat(
                selectedServiceCharges.service_charges
              )

              // Check if the weight is greater than 1 kg and calculate additional charges
              if (PW > 1) {
                const extraWeightCharges = parseFloat(
                  selectedServiceCharges.extra_weight_charges
                )
                totalServiceCharges += extraWeightCharges * (PW - 1) // Calculate additional charges for each additional kg
              }

              // Apply urgency charges if applicable
              if (MS === "Urgent") {
                totalServiceCharges += 100 // Add additional urgent charges
              }
            } else {
              console.error(
                "No service charges found for the provided weight or default weight."
              )
            }

            setFormData(prevData => ({
              ...prevData,
              subtotal_: totalServiceCharges.toFixed(2), // Round to 2 decimal places
              original_subtotal: totalServiceCharges.toFixed(2),
            }))
          } else {
            console.error("No service data found")
          }
        } else {
          console.error("Failed to fetch service data:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching service data:", error)
      })
  }

  //Handel Sender Location
  const handleChange = address => {
    setFormData({ ...FormData, send_location: address })
  }
  const handleSelect = async address => {
    setFormData({ ...FormData, send_location: address })
  }

  //Handle receiver Location
  const handleChange2 = address => {
    setFormData({ ...FormData, receive_location: address })
  }
  const handleSelect2 = async address => {
    setFormData({ ...FormData, receive_location: address })
  }

  //Final Parcel Submit
  const [loading, setLoading] = useState(false)
  const handleSubmit = async () => {
    if (DocumentMode) {
      if (FormData.service_name.length === 0) {
        toastr.error("Set Service Type")
      } else if (FormData.doc_sub_service.length === 0) {
        toastr.error("Set Doc Sub Service")
      } else if (FormData.office_door_option.length === 0) {
        toastr.error("Set Delivery Options")
      } else if (FormData.city_options.length === 0) {
        toastr.error("Set Delivery Options")
      } else if (FormData.no_of_docs == "" || FormData.no_of_docs == "0") {
        toastr.error("Set No Of Docs")
      } else if (FormData.s_fullName.length === 0) {
        toastr.error("Set Sender Full Name")
      } else if (FormData.s_phone.length === 0) {
        toastr.error("Set Sender Ph.no")
      } else if (FormData.s_address.length === 0) {
        toastr.error("Set Sender Address")
      } else if (FormData.payment_method.length === 0) {
        toastr.error("Set Payment Method")
      } else if (
        FormData.doc_cvi_amount !== "" &&
        FormData.doc_cvi_amount !== "0" &&
        FormData.cvi_percent == false
      ) {
        toastr.error("Check The CVI")
      } else {
        setLoading(true)
        try {
          const updatedFormData = {
            ...FormData,
            dep_charges_data: DepChargesData,
            TotalDepChargesAmount,
          }
         
          const response = await axios.post(`${apiURl}/addParcel`, updatedFormData)
          if (response.data.status === "success") {
            // Handle success
            setLoading(false)
            toastr.success("Parcel added successfully")
            navigate("/today_book")
            // console.log("Parcel added successfully")
          } else {
            // Handle failure
            setLoading(false)
            console.error("Failed to add parcel:", response.data.message)
          }
        } catch (error) {
          // Handle error
          setLoading(false)
          console.error("Error adding parcel:", error)
        }
      }
    } else {
      if (FormData.service_name.length === 0) {
        toastr.error("Set Service Type")
      } else if (FormData.sub_service_name.length === 0) {
        toastr.error("Set Sub Service")
      } else if (FormData.sector_.length === 0) {
        toastr.error("Set Sector")
      } else if (FormData.send_location.length === 0) {
        toastr.error("Set Send Location")
      } else if (FormData.receive_location.length === 0) {
        toastr.error("Set Receive Location")
      } else if (FormData.s_fullName.length === 0) {
        toastr.error("Set Sender Full Name")
      } else if (FormData.s_phone.length === 0) {
        toastr.error("Set Sender Ph.no")
      } else if (FormData.s_address.length === 0) {
        toastr.error("Set Sender Address")
      } else if (FormData.r_fullName.length === 0) {
        toastr.error("Set Receiver Full Name")
      } else if (FormData.r_address.length === 0) {
        toastr.error("Set Receiver Address")
      } else if (FormData.payment_method.length === 0) {
        toastr.error("Set Payment Method")
      } else if (
        FormData.contents_value !== "" &&
        FormData.contents_value !== "0" &&
        FormData.cvi_percent == false
      ) {
        toastr.error("Check The CVI")
      } else {
        setLoading(true)
        try {
          
          const response = await axios.post(`${apiURl}/addParcel`, FormData)
          if (response.data.status === "success") {
            // Handle success
            setLoading(false)
            toastr.success("Parcel added successfully")
            navigate("/today_book")
            // console.log("Parcel added successfully")
          } else {
            // Handle failure
            setLoading(false)
            console.error("Failed to add parcel:", response.data.message)
          }
        } catch (error) {
          // Handle error
          setLoading(false)
          console.error("Error adding parcel:", error)
        }
      }
    }
  }

  //Fetch Users
  const fetchUsers = () => {
    const URL = `${apiURl}/fetchUsers`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const Data = response.data.users
          const UserData = Data.filter(item => item.user_id === login_user_id)
          if (UserData) {
            setFormData(prevData => ({
              ...prevData,
              employee_name: UserData[0].full_name,
              employee_id: UserData[0].user_id,
              employee_city: UserData[0].city_,
            }))
          } else {
            setFormData(prevData => ({
              ...prevData,
            }))
          }
        } else {
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
      })
  }
  useEffect(() => {
    fetchUsers()
  }, [])

  //setRider
  const handleRider = selectedOption => {
    setFormData(prevData => ({
      ...prevData,
      assign_to: selectedOption.value,
    }))
    setRname(selectedOption)
  }
  const fetchRiders = (role, login_user_id) => {
    const data = {
      Role: role,
      User_id: login_user_id,
    }
    const URL = `${apiURl}/fetchRiders`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          const rideroption = response.data.riders.map(row => ({
            label: row.full_name,
            value: row.user_id,
          }))
          setRideroption(rideroption)
        } else {
          console.error("Failed to fetch riders:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching riders:", error)
      })
  }

  // Payment Method
  const fethcPaymentMethod = () => {
    const URL = `${apiURl}/fetchPaymentMethod`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const PMethod = response.data.PMethod
          if (PMethod.length > 0) {
            setpaymentm(PMethod)
          }
        } else {
          console.error("Failed to fetch riders:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching riders:", error)
      })
  }

  useEffect(() => {
    fetchServiceName()
    fethcPaymentMethod()
    if (
      FormData.service_name &&
      FormData.sub_service_name &&
      FormData.sector_ &&
      FormData.content_weight
    ) {
      fetchSubServiceChargesData(
        FormData.service_name,
        FormData.sub_service_name,
        FormData.sector_,
        FormData.content_weight
      )
    } else {
      setFormData(prevData => ({
        ...prevData,
        subtotal_: "0",
      }))
    }
  }, [
    FormData.service_name,
    FormData.sub_service_name,
    FormData.sector_,
    FormData.content_weight,
  ])

  useEffect(() => {
    fetchRiders(role, login_user_id)
  }, [role, login_user_id])

  //Google Apis
  useEffect(() => {
    // Check if the google object exists in the global scope
    if (window.google && window.google.maps) {
      setApiLoaded(true)
    } else {
      // If not, wait for the 'google-maps-api-loaded' event
      window.addEventListener("google-maps-api-loaded", () => {
        setApiLoaded(true)
      })
    }
  }, [])

  if (!apiLoaded) {
    return <div>Loading2..</div>
  }
2
  //Doc Send City
  const setDocSendCity = address => {
    setFormData({ ...FormData, send_location: address })
  }
  const setDocrecCity = address => {
    setFormData({ ...FormData, receive_location: address })
  }

  //Service Charges Data Options
  const subServicesOptions = [
    { label: "Over Night", value: "overnight" },
    { label: "Flyer", value: "flyer" },
    { label: "Box", value: "box" },
  ]

  const sectorOption = [
    { label: "Within City", value: "wc" },
    { label: "Same Zone", value: "sz" },
    { label: "Diff Zone", value: "dz" },
  ]

  //weight Options
  const weightOptions = [
    { label: "0.5", value: "0.5" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
  ]

  const handleWeight = selectedOption => {
    setFormData(prevData => ({
      ...prevData,
      content_weight: selectedOption.value,
    }))
    setParcelWeight(selectedOption)
  }

  //Handle SubService
  const handleSubService = selectedOption => {
    if (selectedOption) {
      setFormData(prevData => ({
        ...prevData,
        sub_service_name: selectedOption.value,
      }))
      setSubService(selectedOption)
      // Check the selected sub-service
      if (selectedOption.value === "box") {
        // If selected sub-service is 'box'
        setParcelWeight({
          value: "1",
          label: "1",
        })
      } else {
        // If selected sub-service is not 'box'
        setParcelWeight({
          value: "0.5",
          label: "0.5",
        })
      }
    }
  }

  //Handle Sector
  const handleSector = selectedOption => {
    setFormData(prevData => ({
      ...prevData,
      sector_: selectedOption.value,
    }))
    setSector(selectedOption)
  }

  //Close
  const close = () => {
    navigate("/")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Book Courier" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <CardTitle>Service Info</CardTitle>
                  <Form className="mt-2">
                    <Row>
                      <Col lg="2">
                        <div className="mb-3">
                          <Label htmlFor="formrow-email-Input">
                            Employee Name
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="formrow-email-Input"
                            placeholder=""
                            name="employee_name"
                            value={FormData.employee_name}
                            onChange={handleParcel}
                            disabled
                          />
                        </div>
                      </Col>
                      <Col lg="2">
                        <div className="mb-3">
                          <Label htmlFor="formrow-email-Input">
                            Employee ID
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="formrow-email-Input"
                            placeholder=""
                            name="employee_id"
                            value={FormData.employee_id}
                            onChange={handleParcel}
                            disabled
                          />
                        </div>
                      </Col>
                      <Col lg={DocumentMode ? "4" : "4"}>
                        <div className="mb-3">
                          <Label>Services</Label>
                          <Select
                            value={MainService}
                            onChange={handleMainService}
                            name="service_name"
                            options={MSoption}
                            className="select2-selection"
                          />
                        </div>
                      </Col>

                      {!DocumentMode && (
                        <>
                          <Col lg="2">
                            <div className="mb-3">
                              <Label>
                                Sub Services
                              </Label>
                              <Select
                                value={SubService}
                                onChange={handleSubService}
                                name="sub_service_name"
                                options={subServicesOptions}
                                className="select2-selection"
                              />
                            </div>
                          </Col>
                          <Col lg="2">
                            <div className="mb-3">
                              <Label>Set Sector</Label>
                              <Select
                                value={Sector}
                                onChange={handleSector}
                                name="sector_"
                                options={sectorOption}
                                className="select2-selection"
                              />
                            </div>
                          </Col>
                        </>
                      )}

                      {DocumentMode && (
                        
                        <>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label>
                                Sub Services
                                (
                                  {!(DelOpt1 && DelOpt2) ? (
                                    <span style={{ color: 'red', fontSize: '12px' }}>First select both delivery options to proceed</span>
                                  ) : (
                                    <span style={{ color: 'green', fontSize: '12px' }}>Now you can select Sub Service</span>
                                  )}
                                )
                              </Label>
                            <Select
                              isMulti
                              value={DocSubService}
                              onChange={handleDocSubService}
                              name="doc_sub_service"
                              options={DocSSOption}
                              className={`react-select   ${(DelOpt1 && DelOpt2 && !subS) ? 'glow-success' : ''}`}
                              classNamePrefix="select"
                              isDisabled={!(DelOpt1 && DelOpt2)} 
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: !(DelOpt1 && DelOpt2) ? '#999999' : 'black',
                                  borderColor: !(DelOpt1 && DelOpt2) ? '#d3d3d3' : base.borderColor,
                                  color: !(DelOpt1 && DelOpt2) ? '#999' : base.color,
                                  cursor: !(DelOpt1 && DelOpt2) ? 'not-allowed' : 'default',
                                  opacity: !(DelOpt1 && DelOpt2) ? 0.6 : 1,
                                }),
                                singleValue: (base, state) => ({
                                  ...base,
                                  color: !(DelOpt1 && DelOpt2) ? '#999' : base.color
                                }),
                                multiValue: (base, state) => ({
                                  ...base,
                                  backgroundColor: !(DelOpt1 && DelOpt2) ? '#e0e0e0' : base.backgroundColor
                                })
                              }}
                            />
                          </div>
                        </Col>
                        {DocSubServiceData.map((row, index) => (
                          <div key={row.id} className="mt-2">
                          <Row key={row.id}>
                          <Col lg="3">
                           <Label>Sub Service ({index + 1})</Label>
                           <Input value={row.name} disabled />
                         </Col>
                         <Col lg="3">
                           <Label>No. of Docs</Label>
                           <Input
                             type="number"
                             value={row.doc_count}
                             min={1}
                             onChange={e => handleDocRowChange(index, parseInt(e.target.value))}
                             onWheel={(e) => e.target.blur()}
                             onKeyDown={(e) => {
                              if (e.key === '-' || e.key === 'e' || e.key === '0') {
                                e.preventDefault();
                              }
                            }}
                           />
                         </Col>
                         <Col lg="3">
                           <Label>Rate/Doc</Label>
                           <Input value={row.rate} disabled />
                         </Col>
                         <Col lg="3">
                           <Label>Total</Label>
                           <Input value={row.total} disabled />
                         </Col>
                           </Row>
                           </div>
                        ))}
                        <div className="mt-5 mb-2" >
                        {DepchargesMode && (
                          <div style={{marginTop:'20px !important', border:'1px solid gray', padding:'10px'}}>
                          <CardTitle>Set Department Charges (For Apostille)</CardTitle>
                          {DepChargesData.map((row, index) => (
                            <Row key={row.id}>
                              <Col lg="4">
                                <div className="mb-3">
                                  <Label>Select Type Of Doc</Label>
                                  <Select
                                    value={DepTypeChargesOption.find(option => option.label === DepChargesData[index].dep_charges_name) || null}
                                    onChange={selectedOption => handleDeptypeCharges(index, selectedOption)}
                                    name="dep_charges_name"
                                    options={DepTypeChargesOption}
                                    className="select2-selection"
                                  />
                                </div>
                              </Col>
                              <Col lg="2">
                                <div className="mb-3">
                                  <Label>NO. of Doc</Label>
                                  <Input
                                    min={1}
                                    value={row.dep_charges_selected_no}
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    onChange={e => handleDeptypeChargesDocNum(index, e)}
                                    onKeyDown={(e) => {
                                      if (e.key === '-' || e.key === 'e' || e.key === '0') {
                                        e.preventDefault(); // Prevent negative signs and exponential notation
                                      }
                                    }}
                                    name="dep_charges_selected_no"
                                    className="form-control"
                                  />
                                </div>
                              </Col>
                              <Col lg="2">
                                <div className="mb-3">
                                  <Label>Amount</Label>
                                  <Input
                                    value={row.dep_charges_selected_doc_amount}
                                    type="number"
                                    disabled
                                    name="dep_charges_selected_doc_amount"
                                    className="form-control"
                                  />
                                </div>
                              </Col>
                              <Col>
                              <div className="mt-4">
                              <i
                                      className="mdi mdi-delete font-size-18"
                                      onClick={() => handleDelRow(row.id)}
                                      style={{
                                        color: "#F46A6A",
                                        cursor: "pointer",
                                      }}
                                    />
                                    </div>
                                    </Col>
                            </Row>
                          ))}
                          <Row>
                          <Col lg="4">
                                <div className="mt-4 mb-3">
                                  <Button
                                    onClick={handleAddRow}
                                    color="primary"
                                    className="btn btn-sm"
                                  >
                                    <i className="fa fa-fw fa-plus" />
                                    Add Type
                                  </Button>
                                </div>
                           </Col>
                           <Col lg="2"></Col>
                           <Col lg="2">
                                <div className="mb-3">
                                  <Label>Total Amount</Label>
                                  <Input
                                    value={TotalDepChargesAmount}
                                    type="number"
                                    disabled
                                    className="form-control"
                                  />
                                </div>
                              </Col>
                          </Row>
                        </div>
                        )}
                        </div>
                        </>
                      )}
                    </Row>
                    {!DocumentMode && (
                      <Row>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label htmlFor="address_">Send Location</Label>
                            <PlacesAutocomplete
                              value={FormData.send_location}
                              onChange={handleChange}
                              onSelect={handleSelect}
                            >
                              {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                              }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: "Set send location...",
                                      className: "form-control",
                                      id: "address_",
                                    })}
                                  />
                                  <div>
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map((suggestion, index) => {
                                      const className = suggestion.active
                                        ? "suggestion-item--active"
                                        : "suggestion-item"
                                      const style = suggestion.active
                                        ? {
                                            backgroundColor: "#fafafa",
                                            cursor: "pointer",
                                          }
                                        : {
                                            backgroundColor: "#ffffff",
                                            cursor: "pointer",
                                          }
                                      return (
                                        <div
                                          key={index}
                                          {...getSuggestionItemProps(
                                            suggestion,
                                            {
                                              className,
                                              style,
                                            }
                                          )}
                                        >
                                          <i className="bx bx-map"></i>
                                          <span>{suggestion.description}</span>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label htmlFor="address2_">Receive Location</Label>
                            <PlacesAutocomplete
                              value={FormData.receive_location}
                              onChange={handleChange2}
                              onSelect={handleSelect2}
                            >
                              {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                              }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: "Set receive location...",
                                      className: "form-control",
                                      id: "address2_",
                                    })}
                                  />
                                  <div>
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map((suggestion, index) => {
                                      const className = suggestion.active
                                        ? "suggestion-item--active"
                                        : "suggestion-item"
                                      const style = suggestion.active
                                        ? {
                                            backgroundColor: "#fafafa",
                                            cursor: "pointer",
                                          }
                                        : {
                                            backgroundColor: "#ffffff",
                                            cursor: "pointer",
                                          }
                                      return (
                                        <div
                                          key={index}
                                          {...getSuggestionItemProps(
                                            suggestion,
                                            {
                                              className,
                                              style,
                                            }
                                          )}
                                        >
                                          <i className="bx bx-map"></i>
                                          <span>{suggestion.description}</span>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {DocumentMode && (
            <Row xl="12">
              <Card>
                <CardBody>
                  <CardTitle>Documents Detail</CardTitle>
                  <Row>
                    <Col lg={3}>
                    
                      <div className="mb-3">
                      <label>
                        Delivery Options
                        (
                          {!DelOpt1 ? (
                            <span style={{ color: 'red', fontSize: '10px' }}>Select Me</span>
                          ) : (
                            <span style={{ color: 'green', fontSize: '10px' }}>Selected</span>
                          )}
                        )
                      </label>
                                              <select
                          className={`form-select ${!DelOpt1 ? 'glow-warning' : ''}`}
                          name="office_door_option"
                          value={FormData.office_door_option}
                          onChange={handleOfficDoorService}
                        >
                          <option value='null'>Select...</option>
                          <option value="oto_">Office to Office</option>
                          <option value="otd_">Office to Door Step</option>
                        </select>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <label>
                          Delivery Options
                          (
                          {!DelOpt2 ? (
                            <span style={{ color: 'red', fontSize: '10px' }}>Select Me</span>
                          ) : (
                            <span style={{ color: 'green', fontSize: '10px' }}>Selected</span>
                          )}
                        )
                        </label>
                        <select
                          className={`form-select ${!DelOpt2 ? 'glow-warning' : ''}`}
                          name="city_options"
                          value={FormData.city_options}
                          onChange={handlecityoptions}
                        >
                          <option value="null">Select...</option>
                          <option value="wc_">With-in City</option>
                          <option value="ctc_">City To City</option>
                        </select>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="no_of_docs">No Of Docs.</Label>
                        <Input
                          min={1}
                          type="number"
                          className="form-control"
                          id="no_of_docs"
                          onWheel={(e) => e.target.blur()}
                          name="no_of_docs"
                          onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === '0') {
                              e.preventDefault();
                            }
                          }}
                          disabled
                          value={FormData.no_of_docs}
                          onChange={handledocsNo}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="no_of_docs">CVI Amount</Label>
                        <Input
                          min={1}
                          type="number"
                          className="form-control"
                          name="doc_cvi_amount"
                          onWheel={(e) => e.target.blur()}
                          value={FormData.doc_cvi_amount}
                          onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e') {
                              e.preventDefault(); // Prevent negative signs and exponential notation
                            }
                          }}
                          onChange={handleParcel}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    {wc && (
                      <Col xl="3">
                        <div className="mb-3">
                          <Label htmlFor="address_">Set City</Label>
                          <PlacesAutocomplete
                            value={FormData.send_location}
                            onChange={setDocSendCity}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: "Send location...",
                                    className: "form-control",
                                    id: "address_",
                                  })}
                                />
                                <div>
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion, index) => {
                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item"
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                        }
                                    return (
                                      <div
                                        key={index}
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <i className="bx bx-map"></i>
                                        <span>{suggestion.description}</span>
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </div>
                      </Col>
                    )}
                    {ctc && (
                      <>
                        <Col xl="3">
                          <div className="mb-3">
                            <Label htmlFor="address_">From City</Label>
                            <PlacesAutocomplete
                              value={FormData.send_location}
                              onChange={setDocSendCity}
                            >
                              {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                              }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: "Send location...",
                                      className: "form-control",
                                      id: "address_",
                                    })}
                                  />
                                  <div>
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map((suggestion, index) => {
                                      const className = suggestion.active
                                        ? "suggestion-item--active"
                                        : "suggestion-item"
                                      const style = suggestion.active
                                        ? {
                                            backgroundColor: "#fafafa",
                                            cursor: "pointer",
                                          }
                                        : {
                                            backgroundColor: "#ffffff",
                                            cursor: "pointer",
                                          }
                                      return (
                                        <div
                                          key={index}
                                          {...getSuggestionItemProps(
                                            suggestion,
                                            {
                                              className,
                                              style,
                                            }
                                          )}
                                        >
                                          <i className="bx bx-map"></i>
                                          <span>{suggestion.description}</span>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                          </div>
                        </Col>
                        <Col xl="3">
                          <div className="mb-3">
                            <Label htmlFor="address_">To City</Label>
                            <PlacesAutocomplete
                              value={FormData.receive_location}
                              onChange={setDocrecCity}
                            >
                              {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                              }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: "Receive location...",
                                      className: "form-control",
                                      id: "address_",
                                    })}
                                  />
                                  <div>
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map((suggestion, index) => {
                                      const className = suggestion.active
                                        ? "suggestion-item--active"
                                        : "suggestion-item"
                                      const style = suggestion.active
                                        ? {
                                            backgroundColor: "#fafafa",
                                            cursor: "pointer",
                                          }
                                        : {
                                            backgroundColor: "#ffffff",
                                            cursor: "pointer",
                                          }
                                      return (
                                        <div
                                          key={index}
                                          {...getSuggestionItemProps(
                                            suggestion,
                                            {
                                              className,
                                              style,
                                            }
                                          )}
                                        >
                                          <i className="bx bx-map"></i>
                                          <span>{suggestion.description}</span>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                          </div>
                        </Col>
                      </>
                    )}
                    <Col xl="6">
                      <div className="mb-3">
                        <Label htmlFor="document_detail">Document Detail</Label>
                        <Input
                          type="textarea"
                          id="document_detail"
                          rows="3"
                          placeholder="Detail"
                          name="document_detail"
                          value={FormData.document_detail}
                          onChange={handleParcel}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Row>
          )}

          <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Sender Information</h4>
                  <Form>
                    <Row>
                      <Col lg="8">
                        <div className="mb-3">
                          <Label htmlFor="formrow-firstname-Input">
                            Full Name *
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="formrow-firstname-Input"
                            placeholder="First Name"
                            name="s_fullName"
                            value={FormData.s_fullName}
                            onChange={handleParcel}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label htmlFor="formrow-email-Input">Phone *</Label>
                          <Input
                            type="number"
                            className="form-control"
                            id="formrow-email-Input"
                            placeholder="Ph no"
                            name="s_phone"
                            value={FormData.s_phone}
                            onChange={handleParcel}
                          />
                        </div>
                      </Col>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label htmlFor="cnic_">CNIC</Label>
                          <Input
                            type="number"
                            className="form-control"
                            id="cnic_"
                            placeholder="CNIC"
                            name="s_cnic"
                            value={FormData.s_cnic}
                            onChange={handleParcel}
                          />
                        </div>
                      </Col>
                      <Col xl="12">
                        <div className="mb-3">
                          <Label htmlFor="s_address">Address*</Label>
                          <Input
                            type="textarea"
                            id="s_address"
                            rows="3"
                            placeholder="address"
                            name="s_address"
                            value={FormData.s_address}
                            onChange={handleParcel}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Receiver Information</h4>
                  <Form>
                    <Row>
                      <Col lg="8">
                        <div className="mb-3">
                          <Label htmlFor="formrow-firstname-Input">
                            Full Name *
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="formrow-firstname-Input"
                            placeholder="First Name"
                            name="r_fullName"
                            value={FormData.r_fullName}
                            onChange={handleParcel}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label htmlFor="formrow-email-Input">Phone *</Label>
                          <Input
                            type="number"
                            className="form-control"
                            id="formrow-email-Input"
                            placeholder="Ph no"
                            name="r_phone"
                            value={FormData.r_phone}
                            onChange={handleParcel}
                            disabled={DocumentMode}
                          />
                        </div>
                      </Col>
                      {!DocumentMode && (
                        <Col lg="6">
                          <div className="mb-3">
                            <Label htmlFor="cnic_">CNIC</Label>
                            <Input
                              type="number"
                              className="form-control"
                              id="cnic_"
                              placeholder="CNIC"
                              name="r_cnic"
                              value={FormData.r_cnic}
                              onChange={handleParcel}
                              // disabled={DocumentMode}
                            />
                          </div>
                        </Col>
                      )}

                      <Col xl="12">
                        <div className="mb-3">
                          <Label htmlFor="r_address">Address*</Label>
                          <Input
                            type="textarea"
                            id="r_address"
                            rows="3"
                            placeholder="address"
                            name="r_address"
                            value={FormData.r_address}
                            onChange={handleParcel}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            {DocumentMode ? (
              <>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <CardTitle>Details</CardTitle>
                      <Form>
                        <Row>
                          <Col lg="3">
                            <div className="mb-3">
                              <Label>Assign To</Label>
                              <Select
                                value={Rname}
                                onChange={handleRider}
                                name="assign_to"
                                options={RiderOption}
                                className="select2-selection"
                              />
                            </div>
                          </Col>
                          <Col lg="3">
                            <div className="mb-3">
                              <label>Payment Method</label>
                              <select
                                className="form-select"
                                name="payment_method"
                                value={FormData.payment_method}
                                onChange={handleParcel}
                              >
                                <option>Select..</option>
                                {paymentM && paymentM.length > 0 ? (
                                  paymentM
                                    .filter(e => !!e)
                                    .map(
                                      (
                                        e,
                                        index // Reorder the parameters of the map function
                                      ) => (
                                        <option
                                          key={index}
                                          value={e.method_name}
                                        >
                                          {e.method_name}
                                        </option>
                                      )
                                    )
                                ) : (
                                  <option>No Data Founr</option>
                                )}
                              </select>
                            </div>
                          </Col>

                          <Col lg={3}>
                            <div className="form-check mt-4">
                              <Input
                                type="checkbox"
                                className="form-check-input"
                                id="invalidCheck"
                                onClick={handleDocCheckbox}
                                checked={isChecked}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="invalidCheck"
                              >
                                {" "}
                                CVI (2.5 %)
                              </Label>
                            </div>
                          </Col>
                          <Col lg="3">
                            <div className="mb-3 float-end">
                              <Label htmlFor="Docs_subtotal_">
                                Services Charges (pkr)
                              </Label>
                              <Input
                                type="number"
                                className="form-control"
                                id="Docs_subtotal_"
                                name="Docs_subtotal_"
                                value={Number(FormData.Docs_subtotal_).toFixed(
                                  2
                                )}
                                onChange={handleParcel}
                                disabled
                              />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </>
            ) : (
              <>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Parcel Information</h4>
                      <Form>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label htmlFor="parcel_type">
                                No. Of Contents
                              </Label>
                              <Input
                                type="number"
                                min={1}
                                className="form-control"
                                onWheel={(e) => e.target.blur()}
                                id="parcel_type"
                                name="content_no"
                                value={FormData.content_no}
                                onChange={handleParcel}
                              />
                            </div>
                          </Col>

                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Weight (kg)</Label>
                              <Select
                                value={parcelWeight}
                                onChange={handleWeight}
                                placeholder="Weight"
                                name="content_weight"
                                options={weightOptions}
                                className="select2-selection"
                              />
                            </div>
                          </Col>

                          <Col md={4}>
                            <div className="mb-3">
                              <Label htmlFor="parcel_price">
                                Content Value
                              </Label>
                              <Input
                                type="number"
                                min={0}
                                className="form-control"
                                id="parcel_price"
                                placeholder="0.00"
                                onWheel={(e) => e.target.blur()}
                                name="contents_value"
                                value={FormData.contents_value}
                                onChange={handleParcel}
                              />
                            </div>
                          </Col>
                        </Row>
                        <div className="mb-3">
                          <Label htmlFor="content_info">Content Name</Label>
                          <Input
                            type="textarea"
                            id="content_info"
                            rows="3"
                            placeholder="Content"
                            name="content_info"
                            value={FormData.content_info}
                            onChange={handleParcel}
                          />
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                  <Card>
                    <CardBody>
                      <Form>
                        <Row>
                          <Col lg="3">
                            <div className="mb-3">
                              <Label>Assign To</Label>
                              <Select
                                value={Rname}
                                onChange={handleRider}
                                name="assign_to"
                                options={RiderOption}
                                className="select2-selection"
                              />
                            </div>
                          </Col>
                          <Col lg="3">
                            <div className="mb-3">
                              <label>Payment Method</label>
                              <select
                                className="form-select"
                                name="payment_method"
                                value={FormData.payment_method}
                                onChange={handleParcel}
                              >
                                <option>Select..</option>
                                {paymentM && paymentM.length > 0 ? (
                                  paymentM
                                    .filter(e => !!e)
                                    .map(
                                      (
                                        e,
                                        index // Reorder the parameters of the map function
                                      ) => (
                                        <option
                                          key={index}
                                          value={e.method_name}
                                        >
                                          {e.method_name}
                                        </option>
                                      )
                                    )
                                ) : (
                                  <option>No Data Founr</option>
                                )}
                              </select>
                            </div>
                          </Col>

                          <Col lg={3}>
                            <div className="form-check mt-4">
                              <Input
                                type="checkbox"
                                className="form-check-input"
                                id="invalidCheck2"
                                onClick={handleDocCheckbox}
                                checked={isChecked} // Conditionally set checked attribute
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="invalidCheck2"
                              >
                                {" "}
                                CVI (2.5 %)
                              </Label>
                            </div>
                          </Col>

                          <Col lg="3">
                            <div className="mb-3 float-end">
                              <Label htmlFor="subtotal_">
                                Services Charges (pkr)
                              </Label>
                              <Input
                                type="number"
                                className="form-control"
                                id="subtotal_"
                                name="subtotal_"
                                value={Number(FormData.subtotal_).toFixed(2)}
                                onChange={handleParcel}
                                disabled
                              />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </>
            )}

            <Row className="mb-3">
              <Col xl={4}>
                <Button
                  color="danger"
                  className="btn btn-danger waves-effect waves-light"
                  onClick={close}
                >
                  Close
                </Button>
              </Col>
              <Col xl={8}>
                <div className="float-end">
                  <Button
                    color="success"
                    className={`btn btn-secondary waves-effect waves-light ${
                      loading ? "disabled" : ""
                    }`}
                    onClick={handleSubmit}
                  >
                    Save & Close
                  </Button>
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default CourierInfo
